export interface RumIdentity {
  service: string;
  env: string;
}

const SANDBOX_PREFIX = 'sandbox';

const INTERNAL_HOSTS: Record<string, RumIdentity> = {
  devsp: { service: 'solvace-dev', env: 'dev' },
  qa: { service: 'solvace-qa', env: 'qa' },
  performancetest: { service: 'solvace-performancetest', env: 'performancetest' },
  sandboxefeso: { service: 'solvace-sandboxefeso', env: 'sandboxefeso' },
  sandboxrevamp: { service: 'solvace-sandboxrevamp', env: 'sandboxrevamp' },
  sandboxrt: { service: 'sandboxrt', env: 'prod' },
  www: { service: 'solvace-global', env: 'prod' },
  solvacelabs: { service: 'solvace-global', env: 'prod' },
};

export function resolveRumIdentity(host: string): RumIdentity {
  const subdomain = host.split(':')[0].split('.')[0].toLowerCase();
  const internal = INTERNAL_HOSTS[subdomain];
  if (internal) return internal;

  if (subdomain.startsWith(SANDBOX_PREFIX) && subdomain.length > SANDBOX_PREFIX.length) {
    return { service: `${subdomain.slice(SANDBOX_PREFIX.length)}-sandbox`, env: 'prod' };
  }

  return { service: `${subdomain}-prod`, env: 'prod' };
}
